import { render, staticRenderFns } from "./Channel-data.vue?vue&type=template&id=78702d1f"
import script from "./Channel-data.vue?vue&type=script&lang=js"
export * from "./Channel-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports